import React, { useState, useRef, useEffect } from "react";
import { BarLoader } from "react-spinners";
import classNames from "classnames";
import { useDispatch, useSelector } from "react-redux";
import { createList } from "../actions";
import * as selectors from "../selectors";

const validateUserInput = (userInput, lists, setInputValid) => {
  // To short
  if (userInput.length < 3) {
    setInputValid(false);
    return false;
  }

  // List with name exists
  const listNames = [];
  lists.forEach(list => {
    listNames.push(list.title.rendered);
  });
  if (listNames.includes(userInput)) {
    setInputValid(false);
    return false;
  }

  // OK
  setInputValid(true);
  return true;
};

const useEventListener = (target, type, listener, ...options) => {
  React.useEffect(() => {
    const targetIsRef = target.hasOwnProperty("current");
    const currentTarget = targetIsRef ? target.current : target;
    if (currentTarget)
      currentTarget.addEventListener(type, listener, ...options);
    return () => {
      if (currentTarget)
        currentTarget.removeEventListener(type, listener, ...options);
    };
  }, [target, type, listener, options]);
};

export default () => {
  const inputEl = useRef(null);
  const [userInput, setUserInput] = useState("");
  const [inputValid, setInputValid] = useState(true);
  const dispatch = useDispatch();
  const lists = useSelector(selectors.lists);
  const creatingList = useSelector(selectors.creatingList);
  const handleKeydown = e =>
    e.key === "Enter" &&
    validateUserInput(userInput, lists, setInputValid) &&
    dispatch(createList(userInput)) &&
    setUserInput("");
  useEventListener(inputEl, "keydown", handleKeydown);
  useEffect(() => {
    inputEl.current.focus();
  }, []);

  if (creatingList) {
    return (
      <div className="fav__loader">
        <BarLoader color={"#212529"} />
      </div>
    );
  }

  return (
    <input
      ref={inputEl}
      className={classNames({ invalid: !inputValid })}
      value={userInput}
      onChange={e => {
        if (!inputValid) {
          validateUserInput(e.target.value, lists, setInputValid);
        }
        setUserInput(
          e.target.value.length <= 256
            ? e.target.value
            : e.target.value.substring(0, 256)
        );
      }}
    />
  );
};
